module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"trigger_when":"Trigger when","webhook_url":"Webhook URL"},"id":{"trigger_when":"Aktifkan ketika","webhook_url":"Webhook URL"}}')
  delete Component.options._Ctor
}
